
import { throwError as observableThrowError, Observable, Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { ValidatorFn, AbstractControl } from "@angular/forms";
import { HttpClient, HttpResponse } from "@angular/common/http";
import { Globals } from 'app/services/globals';
import { share } from 'rxjs-compat/operator/share';
import { shareReplay } from 'rxjs/operators';



@Injectable()
export class UtilsService {

  private enableAppModuleSubject = new Subject<any>();
  enableAppModule$ = this.enableAppModuleSubject.asObservable();
  

  constructor(private http: HttpClient, private globals: Globals) { }

  currentUserEmail = (atob(localStorage.getItem("_sc")) === atob(null)) ? atob(localStorage.getItem("_user")) : atob(localStorage.getItem("_sc"));
 // atob(localStorage.getItem("_sc")) || atob(localStorage.getItem("_user"));

  pageAccessRight(currentPageUrl){
    const adminAccess = ["home", "user-list", "edit-user", "add-user", "kiosks-list", "kiosk-payments", "kiosk-reports", "add-kiosk","edit-kiosk", "modules_settings"];
    const clientAccess = ["home","content-text", "news-list", "add-news","edit-news-intranet","visiting-departments",
    "add-visiting-department","edit-visiting-department","edit-department-field",
      "newsletter-list","add-newsletter","edit-newsletter", "newsletter-subscribers", "add-subscriber",
      "kiosks-list", "kiosk-payments","kiosk-reports", "footer","footer-list",
      "slider","slider-list","welcome-list", "faq",
      "departments-list", "add-edit-appointment-department", "appointments-officers-list", 
      "add-edit-appointments-officers", "appointments-list", "add-edit-appointments"];
      const officerAccess = ["appointments-list", "add-edit-appointments"];

    const roleId = (this.globals.userProfile)?this.globals.userProfile.role.rid:  parseInt(localStorage.getItem("_roleId"));
    
    const loggedUser = localStorage.getItem("_user"); //client/admin/bpo
    let currentClient  = localStorage.getItem("_sc");
		
    let hasRights = false
    if( ([1,3,4].indexOf(roleId) > -1 && adminAccess.indexOf(currentPageUrl) >-1) || //daca e admin || BPO si acceseaza o pagina coresp
			(roleId == 2 && clientAccess.indexOf(currentPageUrl)> -1) ||
			([1,3,4].indexOf(roleId) > -1 && currentClient !== null && clientAccess.indexOf(currentPageUrl) >-1) || //daca e admin, are selectat un user si acceseaza paginile clientului
			(roleId == 5 && officerAccess.indexOf(currentPageUrl) > -1)
      ){
			  hasRights = true;
    }
    if(currentClient !== null){ //if I logged in as an admin/BPO and select a client from DashBoard
			return {client: atob(currentClient), right:hasRights};
		}else{
      return {client: atob(loggedUser), right:hasRights};
    }

  }

  public handleError(error: Response | any) {
    // In a real world app, you might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || ''
      const err = body.error || JSON.stringify(body);
      errMsg = JSON.parse(err)
    } else {
      errMsg = error.message ? error.message : error.toString()
    }
    console.error(errMsg)
    return observableThrowError(errMsg)
  }

  AllWhiteSpacesRemover(value: string) {
    value = value.replace(/\s\s+/g, '');
    value = value.trim();
    return value;
  }

  WhiteSpacesRemover(value: string) {
    if (!value) {
      return "";
    }
    value = value.replace(/\s\s+/g, ' ');
    value = value.trim();
    return value;
  }

  NoWhitespaceValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      let charCount = 0
      if (control.value) {
        for (let i = 0; i < control.value.length; i++) {
          if (control.value[i] != ' ') {
            charCount++
          }
        }
      }
      let isWhitespace = charCount < 3;
      let isValid = !isWhitespace;
      return isValid ? null : { 'whitespace': 'value is only whitespace' }

    };
  }

  validatorNoWhiteSpace(item: string) {
    let charCount = 0
    if (item) {
      for (let i = 0; i < item.length; i++) {
        if (item[i] != ' ') {
          charCount++
        }
      }
    }
    let isWhitespace = charCount < 3;
    let isValid = !isWhitespace;
    if (isValid) {
      return false;
    }
    else {
      return true;
    }
  }

  post(url, body): Observable<any> {
    return this.http.post<any>(url, body)
  }

  add(url, body): Observable<any> {
    return this.http.post<any>(url, body)
  }

  get(url): Observable<any> {
    return this.http.get<any>(url)
  }

  delete(url): Observable<any> {
    return this.http.delete<any>(url)
  }

  edit(url, body): Observable<any> {
    return this.http.put<any>(url, body)
  }

  downloadFile(url): Observable<HttpResponse<Blob>> {
    return this.http.get(url, {
      responseType: 'blob',
      observe: 'response',
    });
  }

  //for appointment module
  appointmentStatus$ = this.get(`/admin/appointment/getAllAppointmentStatus`)
                          .pipe(
                            shareReplay(1)
                          )
      

  changeAppModuleEnable(msg:boolean){
    this.enableAppModuleSubject.next(msg);
  }


}
